/**
 * Common Production Station methods for access across all station views
 * 
 */
import buildUrl from 'build-url'
import swal from 'sweetalert2/dist/sweetalert2.min.js'
import 'sweetalert2/dist/sweetalert2.min.css'

import EventBus from '@/utils/eventBus'

import DocumentPreviewDialog from '@/components/dialog/documentPreviewDialog'
import OrderPreviewDialog from '@/apps/glass-production-station/src/views/orderPreviewDialog'
import OrderItemsPreviewDialog from '@/apps/glass-production-station/src/views/orderItemsPreviewDialog'
import OrderItemEditorViewerDialog from '@/apps/glass-production-station/src/views/orderItemEditorViewerDialog'
import RecutPanelDialog from '@/apps/glass-production-station/src/views/recutPanelDialog'
import RecutPanelResultDialog from '@/apps/glass-production-station/src/views/recutPanelResultDialog'
import RevertPanelDialog from '@/apps/glass-production-station/src/views/revertPanelDialog'
import MovePanelDialog from '@/apps/glass-production-station/src/views/movePanelDialog'
import StationScanOptionsDialog from '@/apps/glass-production-station/src/views/stationScanOptionsDialog'

import { ProductionPanelStageTaskStatusTypes } from '@/store/types'

export default {
  methods: {
    displayOrder(order) {
      this.displayModal(OrderPreviewDialog, {
        orderId: order.id
      })
      .then(() => { })
    },
    displayOrderOrderItems(order) {
      this.displayModal(OrderItemsPreviewDialog, {
        orderId: order.id
      })
      .then(() => { })
    },
    displayOrderDocuments(order) {
      this.displayModal(DocumentPreviewDialog, {
        linkType: 'order',
        linkId: order.id
      })
      .then(() => { })
    },
    displayPanelOrder(panel) {
      this.displayModal(OrderPreviewDialog, {
        orderId: panel.orderId
      })
      .then(() => { })
    },
    displayPanelOrderItems(panel) {
      this.displayModal(OrderItemsPreviewDialog, {
        orderId: panel.orderId
      })
      .then(() => { })
    },
    displayPanelOrderDocuments(panel) {
      this.displayModal(DocumentPreviewDialog, {
        linkType: 'order',
        linkId: panel.orderId
      })
      .then(() => { })
    },
    displayPanelOrderEditorView(panel) {
      this.displayModal(OrderItemEditorViewerDialog, {
        orderId: panel.orderId,
        orderItemId: panel.orderItemId
      })
      .then(() => { })
    },
    printPanelLabel(panel) {
      var labelURL = `/production/panels/labels`
      var printParams = { download: true, label: true, panelIDList: [panel.id] }

      var params = $.param(printParams)
      this.$apiService.reportingService.generateReportSignedURL(`${labelURL}?${params}`)
      .then(response => {
        window.location.href = response.data.url
      })
    },
    reprintPanelLabel(panel) {
      var labelURL = `/production/panels/labels`
      var printParams = { download: true, label: true, panelIDList: [panel.id], reprint: true }

      var params = $.param(printParams)
      this.$apiService.reportingService.generateReportSignedURL(`${labelURL}?${params}`)
      .then(response => {
        setTimeout(() => {
          this.displayPopupAlert('success', `Label Printed`, `Label printed for panel ${panel.barcode}`)
        }, 50)

        window.location.href = response.data.url

        EventBus.emitEvent(EventBus.EventTypes.panelLabelPrinted)
      })
    },
    displayPanelRecut(panel, productionStationId) {
      this.displayModal(RecutPanelDialog, {
        productionStationId: productionStationId,
        productionPanelId: panel.id
      })
      .then((recutResult) => {
        if(recutResult) {
          EventBus.emitEvent(EventBus.EventTypes.panelRecut)

          // Display the new panel details
          this.displayModal(RecutPanelResultDialog, {
            panelData: recutResult.productionPanel,
            displayPrintLabel: !recutResult.info.requiresOptimisation
          })
          .then(() => {
          })
        }
      })
    },
    displayPanelRevert(panel, productionStationId) {
      this.displayModal(RevertPanelDialog, {
        productionStationId: productionStationId,
        productionPanelId: panel.id
      })
      .then((success) => {
        if(success)
          this.successToast('Panel tasks reverted')
      })
    },
    displayPanelMove(panel, productionStationId) {
      this.displayModal(MovePanelDialog, {
        productionStationId: productionStationId,
        productionPanelId: panel.id
      })
      .then((success) => {
        if(success)
          this.successToast('Panel moved')
      })
    },

    requestPanelLabelDownload(panelIDList) {
      var labelURL = `/production/panels/labels`
      var printParams = { download: true, label: true, panelIDList: panelIDList }

      var params = $.param(printParams)
      this.$apiService.reportingService.generateReportSignedURL(`${labelURL}?${params}`)
      .then(response => {
        window.location.href = response.data.url
      })
    },

    displayStationScanOptions(productionStationId) {
      this.displayModal(StationScanOptionsDialog, {
        productionStationId: productionStationId
      }, {}, { mountBody: true })
      .then((success) => {
        if(success)
          this.successToast('Scan Options Updated')
      })
    },

    // Display popup for station actions
    // Used instead of StationAlertMessage where the alert message breaks the UI flow or not enough room on the UI
    displayPopupAlert(type, title, messageHTML, options = {}) {
      var alertOptions = {
        title: title,
        html: messageHTML,
        icon: type,

        // Disable animations on hide so inputs get focus straight away
        hideClass: {
          popup: '',
          icon: '',
          backdrop: ''
        }
      }

      // Add a timer for success messages to auto close
      // Of if the timer is requested in the options
      if(type == 'success' || options.hasTimeout) {
        alertOptions.timer = 2500
        alertOptions.timerProgressBar = true
      }
        
      return swal.fire(alertOptions)
    },

    // Display popup for station exception errors
    // Used for displaying internal errors
    displayExceptionErrorAlert(title, error) {
      var errorMessage = error || ''
      if(error.message)
        errorMessage = error.message

      var options = {
        title: title,
        html: errorMessage,
        icon: 'error'
      }
        
      return swal.fire(options)
    }
  }
}
